import { WorkshopOptions } from "@/components/workshops/workshop-options";
import { PublicPageHead } from "@/components/seo/public-page-head";
import { staticPublicPages } from "@/lib/public-seo";
import Link from "next/link";
import { Waves } from "lucide-react";
import { WorkshopStartButton } from "@/components/workshops/workshop-start-button";
import { WorkshopJoinButton } from "@/components/workshops/workshop-join-button";
import { authClient } from "@/lib/auth-client";
import styles from "@/components/workshops/workshops.module.css";

export default function WorkshopsLanding() {
  const account = authClient.useSession();
  return (
    <main className={styles.page}>
      <PublicPageHead page={staticPublicPages.workshops} />
      <nav className={styles.nav}>
        <Link href="/workshops" className={styles.brand}>
          <Waves /> Boardblend <span>/ Workshops</span>
        </Link>
        <Link
          href={
            account.data?.user
              ? "/workshops/dashboard"
              : "/sign-in?returnTo=/workshops/dashboard"
          }
        >
          {account.data?.user ? "My workshops" : "Sign in"}
        </Link>
      </nav>
      <section className={styles.hero}>
        <div className={styles.heroText}>
          <p className={styles.eyebrow}>Bring your people. Bring your AI.</p>
          <h1>Workshops.</h1>
          <h2>Think together. Decide together.</h2>
          <p>
            Start a session. Connect your AI. Let it build the questions while
            your team brings the answers.
          </p>
          <div className={styles.heroActions}>
            <WorkshopStartButton className={styles.primary} />
            <WorkshopJoinButton />
          </div>
          <small>Your AI prepares. Everyone has a say.</small>
        </div>
        <div
          className={styles.poster}
          aria-label="Example workshop question with three answer choices"
        >
          <div className={styles.posterTop}>
            <span>QUESTION 01</span>
            <span>LIVE</span>
          </div>
          <p>
            What should we
            <br />
            build first?
          </p>
          <WorkshopOptions
            question={{
              id: "landing-preview",
              text: "What should we build first?",
              options: [
                "A small prototype",
                "The full experience",
                "More research",
              ],
              optionDescriptions: [
                "Test the idea with a small, useful version.",
                "Build every feature before the first release.",
                "Talk to users before choosing what to build.",
              ],
              recommendedOption: 0,
              recommendation: "Test the idea with a small, useful version.",
              revealed: false,
              decision: "",
            }}
          />
        </div>
      </section>
      <section className={styles.steps}>
        <div>
          <span>01</span>
          <h2>Start. Connect. Go.</h2>
          <p>Your AI sets the goal, questions, choices, and recommendations.</p>
        </div>
        <div>
          <span>02</span>
          <h2>Get everyone thinking.</h2>
          <p>
            Share the link. Choose an answer, or investigate with your own AI.
          </p>
        </div>
        <div>
          <span>03</span>
          <h2>Make the call.</h2>
          <p>Reveal the answers. Explore the differences. Decide together.</p>
        </div>
      </section>
      <footer className={styles.footer}>
        <Link href="/">Explore Boardblend</Link>
        <span>Workshops by Boardblend</span>
      </footer>
    </main>
  );
}
